import React from 'react';
import { Panel } from 'react-bootstrap';
import { ColorPill } from '../../../components/Pill';

const TableContent = (props) => {
  if (!props.excepciones.length) {
    return (
      <tbody>
        <tr>
          <td colSpan='7' className='no-before'>No hay registros
          </td>
        </tr>
      </tbody>
    );
  }

  return props.excepciones.map((excepcion, index) => {
    const isExpanded = index === props.rowSelected;
    const rowClass = isExpanded ? 'as row-expanded' : 'as';

    return (
      <tbody key={excepcion.codSolicitud}>
        <tr className={rowClass}>
          <td>{excepcion.codSolicitud}</td>
          <td>
            <ColorPill estado={excepcion.codEstadoAut}
              descripcion={excepcion.desEstadoAut} />
          </td>
          <td>{excepcion.desTipoAutExcepcional}</td>
          <td>{excepcion.codUsuarioRegul}</td>
          <td>{excepcion.codEstadoRegul}</td>
          <td>{excepcion.fecEstimadaRegul}</td>
          <td onClick={() => props.toggleRow(index)} />
        </tr>
        <tr className='table-extra'>
          <td colSpan='7'>
            <Panel collapsible expanded={isExpanded}
              style={{
                borderColor: 'transparent',
                boxShadow: '0 0 0 white',
                margin: '0',
                backgroundColor: 'inherit'
              }}>
              <div className='collapse in'>
                <div className='table-extra-wrap'>
                  <ul className='row'>
                    <li className='col-md-3'>
                      <p className='labelInfo'>Resp. de Autorización</p>
                      <p>{excepcion.codUsuarioAutoriza}</p>
                    </li>
                    <li className='col-md-3'>
                      <p className='labelInfo'>Fª de Autorización</p>
                      <p>{excepcion.fecAutoriza}</p>
                    </li>
                    {
                      !excepcion.numPedidosVeh &&
                        <li className='col-md-3'>
                          <p className='labelInfo'>Cant. Unidades</p>
                          <p>{excepcion.canVehiculos}</p>
                        </li>
                    }
                    <li className='col-md-3'>
                      <p className='labelInfo'>Fº Creación</p>
                      <p>{excepcion.fecCreacion}</p>
                    </li>
                  </ul>
                  {
                    excepcion.numPedidosVeh &&
                      <div className="row">
                        <div className="col-xs-12">
                          <p className="labelInfo">N° de Pedidos</p>
                          <p>{excepcion.numPedidosVeh}</p>
                        </div>
                      </div>
                  }
                  <div className='row'>
                    <div className='col-xs-12'>
                      <p className='labelInfo'>Observaciones</p>
                      <p>{excepcion.obsSolicitud}</p>
                    </div>
                  </div>
                  <hr className='dark' />
                  <div className='autDetail-actions'>
                    <div className='autDetail-actions-main'>
                      <div className='autDetail-actions-item'
                        onClick={() => props.openNotificar(excepcion)}>
                        <a>
                          <i className='ion-email mr-3 icon-md' />Enviar recordatorio
                        </a>
                      </div>
                      <div className='autDetail-actions-item'
                        onClick={() => props.openEditarSolicitud(excepcion)}>
                        <a>
                          <i className='ion-edit mr-3 icon-md' />Editar solicitud
                        </a>
                      </div>
                    </div>
                    <div className='autDetail-actions-sec'>
                      {
                        excepcion.codEstadoAut === 'P' &&
                        <div className='autDetail-actions-item'>
                          <a className='btn btn-primary'
                            onClick={
                              () => props.showModal('Aprobar',
                              () => props.cambiarEstado(excepcion.codSolicitud,'A'))}>
                            Aprobar
                          </a>
                        </div>
                      }
                      {
                        excepcion.codEstadoAut === 'P' &&
                          <div className='autDetail-actions-item'>
                            <a className='btn btn-default'
                              onClick={() => props.showModal('Rechazar',
                              () => props.cambiarEstado(excepcion.codSolicitud,'R'))}>
                              Rechazar
                            </a>
                          </div>
                      }
                      <div className='autDetail-actions-item'>
                        <a className='btn btn-default autDetail-disable'
                          onClick={() => props.showModal('Inactivar',
                          () => props.anular(excepcion.codSolicitud))}>
                          <i className='ion-trash-a mr-3 icon-md' />
                        </a>
                      </div>
                      {
                        excepcion.codEstadoAut === 'A' &&
                          <div className='autDetail-actions-item'>
                            <div className='btnDrop dropdown customToggle' role='group'>
                              <button className='btn dropdown-toggle btn-blue'>
                                <span>Estado de seguimiento</span>
                                <i className='ion-arrow-down-b ml-2' />
                              </button>
                              <ul className='dropdown-menu'>
                                {
                                  props.seguimientoAutorizaciones.map((entry,index) =>
                                    <li>
                                      <a data-toggle='modal'
                                        onClick={() => props.showEstadoSeguimiento(
                                          entry.codigo,
                                          entry.descripcion,
                                          excepcion.codSolicitud)}>
                                        {entry.descripcion}
                                      </a>
                                    </li>
                                  )
                                }
                              </ul>
                            </div>
                          </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </Panel>
          </td>
        </tr>
      </tbody>
    );
  });
};

export default TableContent;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/ContenidoTablas/Excepciones.js